(function () {
  'use strict';
  // Restrict recognized artist searches only. Other queries keep Shopify's normal
  // typo tolerance, SKU matching, and full-description search.
  var artists = [
    ['KAWS', 'kaws', ['kaws']],
    ['Shepard Fairey', 'shepard-fairey', ['shepard fairey', 'fairey', 'obey']],
    ['Death NYC', 'death-nyc', ['death nyc', 'deathnyc']],
    ['Banksy', 'banksy', ['banksy']],
    ['Mr. Brainwash', 'mr-brainwash', ['mr brainwash', 'mr. brainwash']],
    ['Invader', 'invader', ['invader']],
    ['Cleon Peterson', 'cleon-peterson', ['cleon peterson']],
    ['D*Face', 'dface', ['dface', 'd*face']],
    ['Andy Warhol', 'warhol', ['andy warhol', 'warhol']],
    ['Jean-Michel Basquiat', 'basquiat', ['basquiat', 'jean-michel basquiat']],
    ['Keith Haring', 'haring', ['keith haring', 'haring']],
    ['Taylor Swift', 'taylor-swift', ['taylor swift']]
  ];
  function normalize(value) { return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase(); }
  function queryFor(artist) {
    // The surname permits titles that omit the artist's given name.
    var title = {'warhol':'Warhol','basquiat':'Basquiat','haring':'Haring','mr-brainwash':'Brainwash','dface':'D*Face'}[artist[1]] || artist[0];
    return 'title:"' + title + '" OR vendor:"' + artist[0] + '" OR tag:"artist:' + artist[1] + '"';
  }
  function focusedQuery(value) {
    var artist = artists.find(function (a) { return a[2].indexOf(normalize(value)) !== -1; });
    return artist ? queryFor(artist) : value;
  }
  function displayQuery(value) {
    var artist = artists.find(function (a) { return queryFor(a) === value; });
    return artist ? artist[0] : value;
  }
  function productReference(value, origin) {
    try {
      var url = new URL(value, origin);
      if (url.origin !== origin || !/^\/products\/[a-z0-9-]+\/?$/.test(url.pathname)) return '';
      var variant = url.searchParams.get('variant');
      url.search = ''; url.hash = '';
      if (/^\d+$/.test(variant || '')) url.searchParams.set('variant', variant);
      return url.href;
    } catch (error) { return ''; }
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {focusedQuery:focusedQuery,displayQuery:displayQuery,productReference:productReference};
    return;
  }

  // Handle native GET searches and AJAX filter FormData without altering the
  // visible input or losing existing sort/price/availability parameters.
  document.addEventListener('formdata', function (event) {
    var form = event.target;
    var action;
    try { action = new URL(form.action, location.href); } catch (error) { return; }
    var isSearch = /\/search\/?$/.test(action.pathname) ||
      (/\/search\/?$/.test(location.pathname) && form.querySelector('[name="q"]'));
    if (!isSearch || !event.formData.has('q')) return;
    var types = String(event.formData.get('type') || '').split(',').filter(Boolean);
    if (types.length && types.every(function (type) { return type === 'page' || type === 'article'; })) return;
    var value = event.formData.get('q');
    var focused = focusedQuery(value);
    event.formData.set('q', focused);
    if (displayQuery(focused) !== focused) event.formData.set('type', 'product');
  });

  function refreshSearchLabels() {
    document.querySelectorAll('input[name="q"]:not([type="hidden"])').forEach(function (input) {
      var display = displayQuery(input.value);
      if (display !== input.value) input.value = display;
    });
    var heading = document.querySelector('.gg-search-h1');
    var modernSearch = document.querySelector('[data-gg-product-search]');
    if (modernSearch) {
      var currentQuery = new URL(location.href).searchParams.get('q') || '';
      var plainQuery = displayQuery(currentQuery);
      if (plainQuery !== currentQuery) {
        document.querySelectorAll('.gg-search-tab').forEach(function (link) {
          var url = new URL(link.href, location.origin);
          url.searchParams.set('q', plainQuery);
          link.href = url.toString();
        });
      }
      var countLabel = document.querySelector('#facets-results-count');
      var visibleCount = document.querySelector('.gg-search-count');
      if (countLabel && visibleCount && visibleCount.textContent.trim() !== countLabel.textContent.trim()) visibleCount.textContent = countLabel.textContent.trim();
    }
    if (heading && !modernSearch) {
      var count = document.querySelector('#facets-results-count');
      var label = count ? count.textContent.trim() : heading.textContent.trim();
      artists.forEach(function (artist) {
        var query = queryFor(artist);
        label = label.replace(query, artist[0]);
      });
      if (label && heading.textContent.trim() !== label) heading.textContent = label;
    }
  }
  if (/\/search\/?$/.test(location.pathname)) {
    var current = new URL(location.href);
    var original = current.searchParams.get('q') || '';
    var searchTypes = (current.searchParams.get('type') || '').split(',').filter(Boolean);
    var guideSearch = searchTypes.length && searchTypes.every(function (type) { return type === 'page' || type === 'article'; });
    var focused = guideSearch ? original : focusedQuery(original);
    if (focused !== original) {
      current.searchParams.set('q', focused);
      current.searchParams.set('type', 'product');
      current.searchParams.delete('page');
      location.replace(current.href);
      return;
    }
  }
  refreshSearchLabels();
  // Shopify replaces the search section when filters change.
  var main = document.querySelector('main');
  if (main && window.MutationObserver) new MutationObserver(refreshSearchLabels).observe(main, {childList:true,subtree:true});

  function contextualize(link) {
    if (!/^\/products\//.test(location.pathname) || !link) return;
    var url;
    try { url = new URL(link.href, location.origin); } catch (error) { return; }
    if (url.origin !== location.origin || !/\/pages\/contact\/?$/.test(url.pathname)) return;
    var reference = new URL(location.pathname, location.origin);
    var variant = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (variant && /^\d+$/.test(variant.value)) reference.searchParams.set('variant', variant.value);
    url.searchParams.set('product', reference.href);
    url.hash = 'contact_form';
    link.href = url.href;
  }
  // The custom buy stack is separate from the native Shopify buy-button block.
  var buyStack = document.querySelector('main .gg-buy-stack');
  if (buyStack && /^\/products\//.test(location.pathname) && !buyStack.querySelector('[data-gg-product-inquiry]')) {
    var inquiry = document.createElement('a');
    inquiry.href = '/pages/contact';
    var secondary = buyStack.querySelector('.gg-mao__row');
    inquiry.textContent = secondary && secondary.dataset.inquiryLabel || 'Ask about this piece';
    inquiry.setAttribute('data-gg-product-inquiry', '');
    inquiry.style.cssText = 'display:inline-flex;align-items:center;min-height:44px;text-decoration:underline;font-size:14px;';
    (secondary || buyStack).appendChild(inquiry);
  }
  document.querySelectorAll('a[href*="/pages/contact"]').forEach(contextualize);
  document.addEventListener('click', function (event) {
    contextualize(event.target.closest && event.target.closest('a[href*="/pages/contact"]'));
  }, true);

  var referenceField = document.querySelector('#GGContactProduct');
  if (referenceField && !referenceField.value) {
    var incoming = new URL(location.href).searchParams.get('product');
    if (incoming) referenceField.value = productReference(incoming, location.origin);
  }
})();
